export const USER_CONTACT_REQUEST = 'USER_CONTACT_REQUEST'
export const USER_CONTACT_SUCCESS = 'USER_CONTACT_SUCCESS'
export const USER_CONTACT_FAIL = 'USER_CONTACT_FAIL'
export const USER_CONTACT_RESET = 'USER_CONTACT_RESET'
